import toast from 'react-hot-toast';
import SuccessToast from '../components/Notification/SuccessToast';
import ErrorToast from '../components/Notification/ErrorToast';

const DEFAULT_DURATION = 4000;
const DEFAULT_POSITION = 'top-right';

export function showSuccessToast(message, duration = DEFAULT_DURATION, position = DEFAULT_POSITION) {
  toast(<SuccessToast message={message} />, {
    duration,
    position,
  });
}

export function showErrorToast(message, duration = DEFAULT_DURATION, position = DEFAULT_POSITION) {
  toast(<ErrorToast message={message} />,
    {
      duration,
      position,
    }
  );
}
